import { jsx as _jsx } from "react/jsx-runtime";
var Instagram = function Instagram(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    children: /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M15.836 7.678c-4.493 0-8.147 3.694-8.147 8.233s3.655 8.234 8.147 8.234 8.148-3.694 8.148-8.234-3.655-8.233-8.148-8.233zm0 13.52c-2.885 0-5.232-2.372-5.232-5.287s2.347-5.287 5.232-5.287 5.233 2.372 5.233 5.287-2.347 5.287-5.233 5.287zm8.455-15.59h-.019a1.87 1.87 0 1 0 1.869 1.869V7.467a1.859 1.859 0 0 0-1.85-1.859zm4.827-2.988C27.435.906 25.116.001 22.412.001H9.259C3.721.001 0 3.76 0 9.356v13.217c0 2.796.922 5.179 2.666 6.889 1.693 1.661 3.998 2.539 6.666 2.539h13.006c2.719 0 5.044-.876 6.723-2.533 1.708-1.684 2.61-4.044 2.61-6.823V9.355c0-2.706-.884-5.036-2.554-6.736zm-.362 20.027c0 1.967-.599 3.598-1.732 4.715-1.123 1.109-2.744 1.695-4.685 1.695H9.333c-1.894 0-3.497-.59-4.636-1.707-1.165-1.142-1.781-2.795-1.781-4.776V9.357c0-1.954.59-3.579 1.707-4.702C5.735 3.538 7.338 2.947 9.26 2.947h13.152c1.91 0 3.513.604 4.637 1.749 1.117 1.137 1.707 2.749 1.707 4.661v13.29z"
    })
  });
};
export default Instagram;